import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default {

  add(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
            mutation {
                createCampaignSenderEmail (
                user_id: ${data.user_id},
                name: "${data.name}",
                email: "${data.email}",
              ) {
                  id,
                  user_id,
                  email,
                  name,
                  brevo_id
                }
            }
          `
    })
  },
  fetchPaginated: (sortName = "id", page, itemsPerPage, type = "ASC", word = "") => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', formatGraphqlBody(
      'query',
      'getSenderEmailsPaginated',
      {
        0: 'pagination_page',
        1: 'pagination_limit',
        2: 'total_pages',
        3: 'total_items',
        items: {
          0: 'id',
          1: 'user_id',
          2: 'email',
          3: 'name',
          4: 'brevo_id',
          5: 'status'
        }
      },
      {
        orderBy: [sortName, type],
        search_filter: word,
        pagination_page: page,
        pagination_limit: itemsPerPage
      }
    ));
  },
  delete(id, brevoId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
          mutation {
              deleteCampaignSenderEmail (
                  id: ${id},
                  brevo_id: ${brevoId}
              )
          }
      `
    })
  },
  update(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
          mutation {
              updateCampaignSenderEmail (
                  id: ${data.id}
                  name: "${data.name}",
                  email: "${data.email}",
                  brevo_id: ${data.brevo_id}
              ) {
                  id,
                  user_id,
                  email,
                  name,
                  brevo_id
                }
          }
      `
    })
  },
  validate(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
          mutation {
              validateCampaignSenderEmail (
                  brevo_id: ${data.brevo_id},
                  id: ${data.id}
                  otp: ${data.otp}
              ) 
          }
      `
    })
  },
}
